import { twMerge } from "tailwind-merge";
import ArrowDown from "./ArrowDown";

const ArrowUp = ({ className, ...props }) => {
  return (
    <ArrowDown
      className={twMerge("rotate-180", className)}
      {...props}
    />
  );
};

export default ArrowUp;
